<div class="container">
  <div class="header">
    <div class="title">Importer un profil</div>
  </div>
  <div class="search-bar" fxLayout="column" fxLayoutAlign="start stretch">
    <app-search-bar
      [label]="label"
      placeholder="Rechercher..."
      (isLoadingChange)="onChildLoadingChange($event)"
      [type]="profileType"
      [emitProfileObject]="true"
      (onProfileSelected)="profileChange($event)"
      [fullWidth]="true"
      [selectedProfile]="profile"
    ></app-search-bar>
  </div>
  <div *ngIf="isLoading" fxLayout="column" fxLayoutAlign="center center" class="loader">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
  </div>
  <div fxLayout="row" fxLayoutAlign="end center" class="action">
    <div>
      <app-button (click)="close()" btnType="text" color="primary" text="Annuler"></app-button>
    </div>
    <div class="mg-l-8">
      <app-button (click)="import()" btnType="primary" color="primary" text="Importer"></app-button>
    </div>
  </div>
</div>
